<template>
  <div v-if="charging">
    <div
      class="three w-100 d-flex align-items-center justify-content-center"
      :class="'bg-light'"
      style="height: 100vh;"
    >
      <div class="loader" id="loader-1"></div>
    </div>
  </div>
  <div v-else class="challengeChildApprove">
    <confirmMessage
      :show="showConfirmMessage"
      :updateShow="
        (value) => {
          showConfirmMessage = value;
        }
      "
      :returnValue="(value) => confirmationCallback(value)"
    ></confirmMessage>
    <div class="container">
      <div v-show="showSaveButton" class="confirm-recordatory">
        <p class="recordatory-message">
          Remember to save and confirm any change before leaving this page
        </p>
        <b-button v-show="showSaveButton" @click="sendData" class="confirm-button">
          <div class="button-style">
            <div class="style-shadow"></div>
          </div>
          <label class="button-text">Confirm</label>
        </b-button>
      </div>
      <div v-if="getCheckListAll().length > 0" class="dayTimes-container">
        <div
          v-for="item in dayTimes"
          :key="item.id"
          class="dayTimes"
          :class="getChecklist(item.id).length == 0 ? 'd-none' : ''"
        >
          <label>{{ item.title }}</label>
          <approve-challenge
            :checklist="getChecklist(item.id)"
            :userIsAParent="userIsAParent"
            :time_day="item.id"
            :id="item.id"
            :child="getUserId"
            :date="getTodayDate"
            :ref="item.id"
          />
        </div>
      </div>
      <emptyModule
        v-else
        :icon="'check_circle'"
        :title="'No challenges have been added for you yet.'"
      >
      </emptyModule>
    </div>
    <b-button
      v-show="showSaveButton"
      @click="sendData"
      class="confirm-button button-end my-3"
      style="margin: auto"
    >
      <div class="button-style">
        <div class="style-shadow"></div>
      </div>
      <label class="button-text">Confirm</label>
    </b-button>
  </div>
</template>
<script>
import approveChallenge from '@/components/challenge/approveChallenge.vue';
import emptyModule from '@/components/general/emptyModule.vue';
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';
import confirmMessage from '@/components/challenge/confirmMessage.vue';

function formatDate(date) {
  let _date = new Date(date),
    month = '' + (_date.getMonth() + 1),
    day = '' + _date.getDate(),
    year = _date.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
}
export default {
  components: {
    approveChallenge,
    emptyModule,
    confirmMessage,
  },
  data() {
    return {
      dataToSent: [],
      emptyChellenge: false,
      showModalCalendar: null,
      userIsAParent: false,
      dayTimes: [
        { id: 1, title: 'Morning' },
        { id: 2, title: 'Afternoon' },
        { id: 3, title: 'Evening' },
        { id: 4, title: 'Anytime' },
      ],
      childSaveButtonActives: [],
      showSaveButton: false,
      showEmptyMessage: false,
      showConfirmMessage: false,
      storeNextFunction: () => {},
      wantRedirect: false,
      criterionTimeFrequencyChoices: [],
      charging: false,
    };
  },
  mounted() {
    this.criterionTimeFrequencyChoices = this.getCriterionTimeFrequencyChoices.map(
      (timeFrequency) => {
        return { id: timeFrequency.value, text: timeFrequency.text };
      },
    );
  },
  methods: {
    ...mapActions('challenge', [
      'FetchChildCriterionToday',
      'setParentCheckValues',
      'setChildCheckValues',
    ]),
    makeActive(item) {
      this.activeTab = item;
    },
    confirmationCallback(value) {
      if (value === 'continue') {
        this.storeNextFunction();
      }

      if (value === 'save') {
        this.wantRedirect = true;
        this.sendData();
      }
    },
    findFrequencyTime(frequencyId) {
      return this.criterionTimeFrequencyChoices.find((time) => time.id == frequencyId);
    },
    sendData() {
      this.charging = true;
      this.dataToSent = [];
      const getDataToSendPromises = [];
      const sendDataPromises = [];
      this.childSaveButtonActives.forEach((element) => {
        getDataToSendPromises.push(
          this.$root.$emit('getChallengeCheckedValues-' + element, this.dataToSent),
        );
      });
      Promise.all(getDataToSendPromises).then(() => {
        this.dataToSent.forEach((data) => {
          if (this.userIsAParent) {
            sendDataPromises.push(
              this.setParentCheckValues({
                time_day: data.timeId,
                date: data.date,
                items: data.toSend,
              }),
            );
          } else {
            sendDataPromises.push(
              this.setChildCheckValues({
                time_day: data.timeId,
                date: data.date,
                items: data.toSend,
              }),
            );
          }
        });
        Promise.all(sendDataPromises).then(() => {
          if (this.wantRedirect) {
            this.storeNextFunction();
          }
          this.FetchChildCriterionToday(this.getUserId).then(() => {
            this.showSaveButton = false;
            this.charging = false;
          });
        });
      });
    },
    activeSaveButton(val, setter) {
      if (val) {
        this.childSaveButtonActives.push(setter);
      } else {
        const filtered = this.childSaveButtonActives.filter(function(value) {
          return value != setter;
        });
        this.childSaveButtonActives = filtered;
      }
      this.showSaveButton = this.childSaveButtonActives.length > 0;
    },
    getChecklist(id) {
      let criteria = [];
      this.getCriterionToday.forEach((element) => {
        if (element.time_day == id) {
          element.criterion.forEach((item) => {
            criteria.push({
              id: item.id,
              approvedChild: item.child_approved,
              approvedParent: item.parent_approved,
              qualifiedParent: item.parent_qualified,
              coin_value: item.coin_value,
              text: item.text,
              criterionId: `${item.challenge_criterion}-${item.id}`,
            });
          });
        }
      });
      return criteria;
    },
    getCheckListAll() {
      let criteria = [];
      this.getCriterionToday.forEach((element) => {
        if (element.time_day) {
          element.criterion.forEach((item) => {
            criteria.push({
              id: item.id,
              approvedChild: item.child_approved,
              approvedParent: item.parent_approved,
              qualifiedParent: item.parent_qualified,
              coin_value: item.coin_value,
              text: item.text,
              criterionId: `${item.challenge_criterion}-${item.id}`,
            });
          });
        }
      });
      return criteria;
    },
  },
  computed: {
    ...mapGetters('user', ['getUsrId', 'getUserName', 'getUserId', 'getParentName']),
    ...mapGetters('challenge', ['getCriterionToday', 'getCriterionTimeFrequencyChoices']),
    getTodayDate() {
      return formatDate(Date(Date.now()));
    },
  },
  beforeRouteEnter(to, from, next) {
    let userId = store.getters['user/getUserId'];
    Promise.all([
      store.dispatch('challenge/FetchChildCriterionToday', userId),
      store.dispatch('challenge/fetchCriterionTimeFrequencyChoices'),
    ]).then(() => {
      next();
    });
  },
  beforeRouteLeave(to, from, next) {
    if (!this.showSaveButton) {
      next();
    } else {
      this.storeNextFunction = () => next();
      next(false);
      this.showConfirmMessage = true;
    }
  },
};
</script>
<style scoped lang="scss">
* {
  position: relative;
  margin: 0;
  padding: 0;
}

.max-button-width {
  min-width: 300px;
  max-width: 400px;
}

.container {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5em;
  justify-content: center;
  font-size: 1rem;
  margin: 2rem auto;
  width: min(90%, 1366px);
  padding: 0;
}

.confirm-recordatory {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 0.5em 1em;
  border: 2px dashed #c9f0a7;
  border-radius: 20px;
  margin: 0 1rem;

  .recordatory-message {
    text-align: center;
  }
}

.confirm-button {
  display: flex;
  background-color: #ffe27e;
  justify-content: center;
  align-items: center;
  padding: 0.4em 1.5em;
  transition: 150ms;
  border-radius: 10px;
  border: none;

  &:hover {
    transform: scale(1.1);
    cursor: pointer;
  }

  .button-style {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
    border-radius: 10px;

    .style-shadow {
      background: #ffe27e;
      mix-blend-mode: multiply;
      position: absolute;
      width: 100%;
      height: 50%;
      border-bottom-left-radius: 100%;
      border-bottom-right-radius: 100%;
      opacity: 0.5;
    }
  }

  .button-text {
    color: black;
    text-align: center;

    &:hover {
      cursor: pointer;
    }
  }
}

.button-end {
  width: 30%;
}

.dayTimes-container {
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  gap: 1.5em;
  justify-content: space-between;
  font-size: 1rem;
  width: min(90%, 1366px);
}

.dayTimes {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 0.5em;
  width: min(100%, 380px);
  & > label {
    color: #1e90ff;
    font-size: 1.15rem;
  }
}
</style>
